import type { Donation, DonationList } from '@/models/interface/donation';
import type { DiscountList, DiscountTypeList, SubscriptionData } from '@/models/interface/pay';
import { ApiFactory, type ApiDataResponse, type ApiResponse } from '@/utils/api';

export class DonationService extends ApiFactory {
  constructor() {
    super('Donation');
  }

  /**
   * 取得所有可捐贈的機構資料
   * @returns
   */
  getDonationList(): Promise<ApiDataResponse<DonationList[]>> {
    return this.get(`Institution/All`);
  }

  /**
   * 查詢捐款金額（未捐款）
   * @returns
   */
  pendingAmount(): Promise<ApiDataResponse<number>> {
    return this.get(`Transaction/Amount?Status=0`);
  }
  
  /**
   * 查詢捐款金額（已捐款）
   * @returns
   */
  completeAmount(): Promise<ApiDataResponse<number>> {
    return this.get(`Transaction/Amount?Status=1`);
  }

  /**
   * 立即捐贈
   * @param data 
   * @returns 
   */
  updateByOrder(data: Donation): Promise<ApiResponse> {
    return this.put(`Transaction/UpdateByOrder`, data);
  }
}
